import { useMutation } from "@apollo/client";
import {
  ConfirmOrderDocument,
  GetOrderByIdDocument,
} from "../../gql/generated/graphql";

interface Props {
  orderId: string;
}

export const useConfirmOrder = ({ orderId }: Props) => {
  const [confirmOrder] = useMutation(ConfirmOrderDocument, {
    refetchQueries: [GetOrderByIdDocument],
  });

  return {
    confirmOrder: async ({
      deliveryDate,
      isRush,
    }: {
      deliveryDate: Date;
      isRush: boolean;
    }) => {
      await confirmOrder({
        variables: {
          orderId,
          deliveryDate,
          isRush,
        },
      });
    },
  };
};
